import React from 'react';
import ButtonOwnDays from '../../../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';
import './HomeStoreSection.scss';
import LazyLoadBackgroundImage from '../../../CommonComponents/LazyLoadBackgroundImage/LazyLoadBackgroundImage';
const HomeStoreSection = ({ data }) => {
  const handleShopBtn = href => {
    // OD__CLEVERTAP__EVENT (cta_click)

    window.location.assign(href);
  };

  return (
    <div className="od-home-store-section" style={{ flexDirection: data.flexDirection }}>
      <div className="od-home-store-section__info">
        <div className="od-home-store-section__info__title">{data.title}</div>
        {data.description ? (
          <div className="od-home-store-section__info__description">{data.description}</div>
        ) : null}
        {data.subText ? (
          <div className="od-home-store-section__info__subtext">{data.subText}</div>
        ) : null}
        <ButtonOwnDays
          classes="od-home-store-section__info__button"
          fontClass="od-font-reg"
          fontSize="20px"
          mode="oval-white"
          px="40px"
          py="12px"
          text={data.btn.text}
          onClick={() => handleShopBtn(data.btn.href)}
        />
      </div>
      <LazyLoadBackgroundImage
        className="od-home-store-section__image"
        src={data.imgSrc}
      ></LazyLoadBackgroundImage>
    </div>
  );
};

export default HomeStoreSection;
